import script from "./AbstractsClose.vue?vue&type=script&setup=true&lang=js"
export * from "./AbstractsClose.vue?vue&type=script&setup=true&lang=js"

import "./AbstractsClose.vue?vue&type=style&index=0&id=1a7e512c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a7e512c"]])

export default __exports__